export class BmMask {
	public static maskFunctions: Record<string, (value: any, fallback: any) => string> = {
		"000": (value: string): string => {
			if (value === "") {
				return undefined;
			}

			let output = "";
			const numberValue = Math.round(Number(String(value).replace(/[^\d,.-]/g, "")));

			if (Number.isNaN(numberValue)) {
				return undefined;
			}

			const newValue = numberValue.toString();
			for (let i = 0; i < newValue.length; i++) {
				if ((newValue.length - i - 1) % 3 === 2) {
					output += " ";
				}

				output += newValue[i];
			}

			if (output.startsWith(" ")) {
				return output.substr(1);
			}

			return output;
		},
		"+000": (value: string): string => {
			if (value === "") {
				return undefined;
			}

			let output = "";
			let numberValue = Math.round(Number(String(value).replace(/[^\d,.-]/g, "")));

			if (Number.isNaN(numberValue)) {
				numberValue = 0;
				output = "0";
			} else {
				const absValue = Math.abs(numberValue).toString();
				for (let i = 0; i < absValue.length; i++) {
					if ((absValue.length - i - 1) % 3 === 2) {
						output += " ";
					}

					output += absValue[i];
				}
			}

			// Kezdő szóköt levágása
			if (output.startsWith(" ")) {
				output = output.substr(1);
			}

			// ElőjelezésZ
			if (numberValue < 0) {
				return `-${output}`;
			}

			return `+${output}`;
		},
		"|000|": (value: string): string => {
			if (value === "") {
				return undefined;
			}
			let output = "";
			let numberValue = Number(String(value).replace(/[^\d,.-]/g, ""));

			if (Number.isNaN(numberValue)) {
				numberValue = 0;
			}
			numberValue = Math.abs(Math.round(numberValue));
			const newValue = String(numberValue);
			for (let i = 0; i < newValue.length; i++) {
				if ((newValue.length - i - 1) % 3 === 2) {
					output += " ";
				}
				output += newValue[i];
			}

			if (output.startsWith(" ")) {
				return output.substr(1);
			}

			return output;
		},
		"0,00": (value: string) => {
			if (value === "") {
				return undefined;
			}

			const numberValue = parseFloat(
				String(value)
					.replace(/[^\d,.-]/g, "")
					.replace(",", ".")
					.split(".", 2)
					.join("."),
			)
				.toFixed(2)
				.toString();

			return numberValue;
		},
		"0": (value: string): string => {
			if (value === "") {
				return undefined;
			}

			const numberValue = Number(String(value).replace(/[^\d,.-]/g, ""));

			if (Number.isNaN(numberValue)) {
				return "0";
			}

			return numberValue.toString();
		},
		"Y-m-d": (value: string) =>
			String(value)
				.replace(/[^\d,.-]/g, "-")
				.substr(0, 10),
		YYYY: (value: string) =>
			String(value)
				.replace(/[^\d,.-]/g, "")
				.substr(0, 4),
		"Y.m.": (value: string) => String(value).split("-").slice(0, 2).join(". "),
	};

	public static unmaskFunctions: Record<string, (value: string, fallback: any) => any> = {
		bool: (value: string): boolean => {
			if (value === "true" || value === "on") {
				return true;
			}

			if (value == "false" || value === "off") {
				return false;
			}

			return undefined;
		},
		"000": (value: string): number => {
			if (value === "") {
				return undefined;
			}
			const numberValue = Number(String(value).replace(/[^\d.-]/g, ""));

			if (Number.isNaN(numberValue)) {
				return undefined;
			}

			return numberValue;
		},
		"0": (value: string): number => {
			if (value === "") {
				return undefined;
			}
			const numberValue = Number(value);

			if (Number.isNaN(numberValue)) {
				return 0;
			}

			return numberValue;
		},
		"0,00": (value: string): number => {
			if (value === "") {
				return undefined;
			}

			const numberValue = Number(value);

			if (Number.isNaN(numberValue)) {
				return undefined;
			}

			return numberValue;
		},
		"Y-m-d": (value: string) =>
			String(value)
				.replace(/[^\d]/g, "-")
				.split("-")
				.filter((x) => x.length > 0)
				.slice(0, 3)
				.join("-"),
		YYYY: (value: string) => +String(value).replace(/[^\d]/g, "").substr(0, 4),
	};

	public static addMask(mask: string, f: (value: string, fallback: any) => string): void {
		BmMask.maskFunctions[mask] = f;
	}

	public static addUnmask(mask: string, f: (value: string, fallback: any) => any): void {
		BmMask.unmaskFunctions[mask] = f;
	}

	public static mask(value: string, mask: string, fallback: any = undefined): string {
		if (typeof BmMask.maskFunctions[mask] === "function") {
			return BmMask.maskFunctions[mask](value, fallback);
		}

		return value;
	}

	public static unmask(value: string, mask: string, fallback: any = undefined): any {
		if (typeof BmMask.unmaskFunctions[mask] === "function") {
			return BmMask.unmaskFunctions[mask](value, fallback);
		}

		return value;
	}
}
